import React from 'react'
import BookingsText from '../../static/text/bookings';

function BookingInformationSection() {
    return (
        <div className='flex flex-col items-center'>
            <p>{BookingsText.contact.header}</p>
            <table className='flex flex-none my-4'>
                <tbody>
                    <tr>
                        <td className='text-right pr-2'>Cell :</td>
                        <td className='text-left'>
                            <a className="text-blue-500 underline" href={"tel:" + BookingsText.contact.info.cell}>{BookingsText.contact.info.cell}</a>
                        </td>
                    </tr>
                    <tr>
                        <td className='text-right pr-2'>Email :</td>
                        <td className='text-left'>
                            <a className="text-blue-500 underline" href={"mailto:" + BookingsText.contact.info.email}>{BookingsText.contact.info.email}</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p>{BookingsText.contact.footer}</p>
        </div >
    )
}

export default BookingInformationSection